import { Fragment, createContext, useContext } from "react";
import { Outlet, useLoaderData } from "react-router";
import Footer from "src/components/shared/footer/Footer/Footer";
import { TopContactBar } from "src/components/shared/navigation/TopContactBar/TopContactBar";
import TopNavigation from "src/components/shared/navigation/TopNavigation/TopNavigation";
// import ColorPickerDebug from "src/components/shared/ColorPickerDebug";
// import { useThemeColor } from "src/hooks/useThemeColor";

// const ColorChangeContext = createContext({
//   color: "",
// });

// export const useColorChangeContext = () => useContext(ColorChangeContext);

function WithNavigationLayout() {
  const { footer } = useLoaderData();
//   const { color, showColorPicker, setCustomColor, resetColor } = useThemeColor();

  return (
    <Fragment>
      <TopContactBar />
      <TopNavigation />
      {/* <ColorChangeContext.Provider value={{ color }}> */}
        <Outlet />
      {/* </ColorChangeContext.Provider> */}

      {/* <ColorPickerDebug
        color={color}
        onColorChange={setCustomColor}
        onReset={resetColor}
        visible={showColorPicker}
      /> */}

      <Footer data={footer.data} />
    </Fragment>
  );
}

export default WithNavigationLayout;
